// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"homepage-badge_shadow__3UsUU","badge":"homepage-badge_badge__30re1"};